// extracted by mini-css-extract-plugin
module.exports = {"Main":"AppHome_Main___-7H2"};